import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  getDashboardData(url: string): Observable<any> {
    return this.http.get(url);
  }

  getLoadDataStatus(url: string, params?: any): Observable<any> {
    return this.http.get(url, { params: params });
  }

  getDashboardLoadSummary(url: string, params?: any) {
    return this.http.get(url, { params: params });
  }

  saveUserPreference(url: string, body: any): Observable<any> {
    return this.http.post(url, body);
  }

  getUserPreference(url: string): Observable<any> {
    return this.http.get(url);
  }

  publishMessage(url: string, payload: any): Observable<any> {
    return this.http.post(url, payload);
  }

  resetInstallation(url: string, practiceId: string): Observable<any> {
    return this.http.post(url, { practiceId: practiceId });
  }

  deleteLoad(url: string, practiceLoadDetailId: string): Observable<any> {
    return this.http.delete(url);
  }
}
